import { useAnimatedDimensionStyle } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/parts/CategoryWithSubcategories/parts/Subcategories/parts/Collapsible/hooks'
import { FC, ReactNode, RefObject } from 'react'
import { LayoutChangeEvent, View } from 'react-native'
import Animated, { SharedValue, useSharedValue } from 'react-native-reanimated'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface CollapsibleProps {
    children: ReactNode
    expanded: SharedValue<boolean>
    horizontal?: boolean
    ref: RefObject<View | null>
}

const Collapsible: FC<CollapsibleProps> = ({ children, expanded, horizontal = false, ref }) => {
    const dimension = useSharedValue(0)

    const animatedDimensionStyle = useAnimatedDimensionStyle(dimension, expanded, horizontal)

    const { styles } = useStyles(stylesheet, { horizontal })

    const handleLayout = (e: LayoutChangeEvent) =>
        (dimension.value = horizontal ? e.nativeEvent.layout.width : e.nativeEvent.layout.height)

    const key = horizontal ? 'horizontal' : 'vertical'

    return (
        <Animated.View
            collapsable={false}
            key={key}
            ref={ref}
            style={[styles.outerContainer, animatedDimensionStyle]}
        >
            <View onLayout={handleLayout} style={styles.innerContainer}>
                {children}
            </View>
        </Animated.View>
    )
}

const stylesheet = createStyleSheet({
    outerContainer: {
        overflow: 'hidden',
    },
    innerContainer: {
        gap: 8,
        position: 'absolute',
        variants: {
            horizontal: {
                true: {
                    flexDirection: 'row',
                    paddingLeft: 8,
                },
                false: {
                    width: '100%',
                    paddingTop: 8,
                },
            },
        },
    },
})

export default Collapsible
